import Vue from "vue";
import VueRouter from "vue-router";
import { getUserData, isUserLoggedIn, userRole } from "@/auth/utils";
import clients from "@/router/clients";
import delivery from "@/router/delivery";
import banners from "@/router/banners";
import products from "@/router/products";
import order from "@/router/orders";
import shippingCompany from "@/router/shippingcompany";
import defaultcategory from "@/router/defaultcategory";
import marketplaces from "@/router/marketplace";
import affiliates from "@/router/affiliate";
import system from "@/router/system";
import coupons from "@/router/coupons";
import pdv from "@/router/pdv";
import priceMonitoring from "@/router/price-monitoring";
import crossdoking from "@/modules/crossdokking/routes";
import coreCategories from "@/views/Categories/CoreCategories/routes";
import ecommerceSettings from "@/modules/Ecommerce/routes";
import adminRoutes from "@/modules/admin/routes";
import saleChannelsRoutes from "@/modules/marketplace/routes";
import productEnrichmentRoutes from "@/modules/Products/routes";
import integrations from "@/router/integrations";
import integrationModuleRoutes from "@/modules/integration/routes";
import tendenciasRoutes from "@/modules/tendencias/routes";


// :routes-imports://
Vue.use(VueRouter);

const routes = [
  {
    path: "/usuarios",
    name: "usuarios",
    component: () => import("@/views/users/UsersList.vue"),
    meta: {
      roles: [5],
      pageTitle: "Usuários",
      breadcrumb: [
        {
          text: "Usuários",
          active: true
        }
      ]
    }
  },
  {
    path: "/",
    name: "home",
    component: () => import("@/views/dashboards/Analytics.vue"),
    meta: {
      roles: [1, 2, 5, 6,4, 8],
      pageTitle: "Dashboards",
      breadcrumb: [
        {
          text: "Resumo",
          active: true
        }
      ]
    }
  },
  {
    path: "/actions-store-view",
    name: "actions-store-view",
    component: () => import("@/views/dashboards/ActionsStoreView.vue"),
    meta: {
      roles: [1, 2, 5, 6],
      pageTitle: "Ações do Lojista",
      breadcrumb: [
        {
          text: "Resumo",
          active: true
        }
      ]
    }
  },
  {
    path: "/minha-conta",
    name: "minha-conta",
    component: () => import("@/views/users/account-setting/AccountSetting.vue"),
    meta: {
      roles: [1, 2, 5, 6],
      pageTitle: "Minha Conta",
      breadcrumb: [
        {
          text: "Minha Conta",
          active: true
        }
      ]
    }
  },
  {
    path: "/aprovar-cadastro-produtos",
    name: "approve-product.description.index",
    component: () => import("@/views/products/approval-product-review/ReviewProductList.vue"),
    meta: {
      roles: [1, 2, 5, 6],
      pageTitle: "Produtos",
      breadcrumb: [
        {
          text: "Revisão de produtos",
          active: true
        }
      ]
    }
  },
  {
    path: "/categories",
    name: "product.categories.index",
    component: () => import("@/views/products/categories/CategoriesList.vue"),
    meta: {
      roles: [1, 2, 5, 6],
      pageTitle: "Categorias",
      breadcrumb: [
        {
          text: "Cadastro de Categoria",
          active: true
        }
      ]
    }
  },
  {
    path: "/product-feed",
    name: "product.feed.index",
    component: () => import("@/views/products/feed/ProductFeed.vue"),
    meta: {
      roles: [5],
      pageTitle: "Feed de Produtos",
      breadcrumb: [
        {
          text: "Feed de Produtos",
          active: true
        }
      ]
    },
  },

  {
    path: "/login",
    name: "login",
    component: () => import("@/views/LoginCentered.vue"),
    meta: {
      layout: "full"
    }
  },
  {
    path: "/perdi-minha-senha",
    name: "perdi-minha-senha",
    component: () => import("@/views/auth/ForgotPassword.vue"),
    meta: {
      layout: "full"
    }
  },

  {
    path: "/recuperar-senha/:token",
    name: "recuperar-senha",
    component: () => import("@/views/auth/ResetPassword.vue"),
    meta: {
      layout: "full"
    }
  },
  {
    path: "/error-404",
    name: "error-404",
    component: () => import("@/views/error/Error404.vue"),
    meta: {
      layout: "full"
    }
  },
  {
    path: "*",
    redirect: "error-404"
  }
];
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    ...routes,
    ...clients,
    ...delivery,
    ...banners,
    ...products,
    ...order,
    ...shippingCompany,
    ...defaultcategory,
    ...marketplaces,
    ...affiliates,
    ...system,
    ...coupons,
    ...pdv,
    ...priceMonitoring,
    ...crossdoking,
    ...coreCategories,
    ...ecommerceSettings,
    ...adminRoutes,
    ...saleChannelsRoutes,
    ...productEnrichmentRoutes,
    ...integrations,
    ...integrationModuleRoutes,
    ...tendenciasRoutes,
// :routes-unpack://
  ]
});
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return new Promise((resolve, reject) => {
    originalPush.call(this, location, () => {
      // on complete

      resolve(this.currentRoute)
    }, error => {
      // on abort

      // only ignore NavigationDuplicated error
      if (error.name === 'NavigationDuplicated') {
        resolve(this.currentRoute)
      } else {
        reject(error)
      }
    })
  })
}
router.beforeEach(async (to, from, next) => {
  let env = process.env.VUE_APP_ENV;
  if (env === "development") {
    env = "production";
  }
  if (to.name === "error-404" || to.name === "login" || to.name === "perdi-minha-senha"
    || to.name === "recuperar-senha" || to.name === "pdv" || to?.public === true) {
    await router.app.$store.dispatch("route/setLastRoute", from.fullPath);
    return next();
  }
  if (to.name && to.name.length) {
    if (!isUserLoggedIn()) {
      router.push("login");
      return false;
    }
    const roles = to.meta.roles || [];

    if (!roles.find(item => item === userRole())) {
      router.push({ name: "login" });
      return false;
        }
        const requiredService = to.meta.need_service
        if (requiredService) {
            const currentUser = getUserData()
            const storeServices = currentUser?.store?.services || []
            if (!storeServices.find(service => service === requiredService)) {
                router.push({name: 'login'})
                return false
            }
        }
        let itemEnv = to.meta.env || [env]
        if (userRole() === 5) {
            itemEnv = [env]
        }
        const hasItemEnv = itemEnv.find(cenv => cenv === env)
        if (!hasItemEnv) {
            router.push({name: 'login'})
            return false
    }
  }

  const url = new URL(window.location.href);
  const lastRoute = url.pathname + url.search;
  await router.app.$store.dispatch("route/setLastRoute", lastRoute);
  return next();
  return true;
});

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;
